<section [class]="sectionClass" [class.page-offset]="withOffset">
  <div [class]="containerClass">
    <ng-content></ng-content>
  </div>
</section>